module.exports = __webpack_public_path__ + "img/zivocs-logo-200x200.aadaa1b2.png";